export const color = {
  black: "#000",
  darkgrey: "#222",
  grey: "#ccc",
  lightgrey: "#dedede",
  white: "#fff",
  darkred: "#a8001c",
  lightred: "#ff0000",
  red: "#dc0a2d",
  lightblue: "#29acff",
  yellow: "#ffff00",
  mostard: "#eaa526",
  green: "#008000",
  changeBackground: "rgb(33, 37, 41, 0.8)",
  transparentBlack: "rgba(0, 0, 0, 0.2)",
  changeText: "#fffafa",
  pokedexBackground: "#333",
  grass: "#b2dfb2",
  poison: "#d592d5",
  fire: "#ffd1b5",
  flying: "#eae3ff",
  water: "#c2f3ff",
  bug: "#e0e8a2",
  normal: "#e6e6c3",
  electric: "#fff1ba",
  ground: "#e0ccb1",
  fighting: "#fcada9",
  psychic: "#ffc9da",
  rock: "#f0e09c",
  fairy: "#ffdee5",
  steel: "#e6eaf0",
  ice: "#e8feff",
  ghost: "#dbbaff",
  dragon: "#c4bdff",
  dark: "#a9abb0",
}
